<template>
  <div class="panel panel-default">
    <div class="panel-body">
      <div v-if="daysRemaining > 0">
        <div class="tw-text-center tw-text-8xl">
          {{ daysRemaining }}
        </div>

        <div class="tw-text-center">
          business days remaining
        </div>
      </div>

      <div v-else>
        <div class="tw-text-center tw-text-4xl tw-text-red-500">
          The deadline has passed!
        </div>
      </div>

      <div class="tw-mt-8 tw-text-gray-400 tw-text-center">
        Content Deadline: {{ publication.attributes.content_deadline_at | date }}
      </div>

      <div class="tw-text-gray-400 tw-text-center">
        Publication Date: {{ publication.attributes.publish_at | date }}
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    publication: {
      required: true
    }
  },

  computed: {
    daysRemaining() {
      let current = moment()

      let count = 0

      while (current <= moment(this.publication.attributes.content_deadline_at)) {
        if (current.format('E') !== '6' && current.format('E') !== '7') {
          count++
        }

        current = current.add(1, 'days')
      }

      return count
    }
  }
}
</script>